'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@emotion/react');
var index = require('../../../../_virtual/index.cjs');

/**
 * SVG Illustration of supplements
 */ const Supplements = ({ assetColor = index.cjsExports.ASSET_COLORS.grey, size = index.cjsExports.ILLUSTRATION_DIMENSIONS.medium, ...rest })=>{
    const theme = react.useTheme();
    return /*#__PURE__*/ jsxRuntime.jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 104 104",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...rest,
        children: [
            /*#__PURE__*/ jsxRuntime.jsx("circle", {
                cx: "52",
                cy: "52",
                r: "52",
                fill: theme.ds5.asset[assetColor].background
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "57.1836",
                y: "8.63867",
                width: "42.656",
                height: "14.9719",
                rx: "7.48594",
                transform: "rotate(75.8174 57.1836 8.63867)",
                fill: theme.ds5.asset[assetColor]["400"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "94.582",
                y: "55.8262",
                width: "42.656",
                height: "14.9719",
                rx: "7.48594",
                transform: "rotate(138.845 94.582 55.8262)",
                fill: theme.ds5.asset[assetColor]["400"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "18.3789",
                y: "43.5234",
                width: "42.656",
                height: "14.9719",
                rx: "7.48594",
                transform: "rotate(19.6922 18.3789 43.5234)",
                fill: theme.ds5.asset[assetColor]["400"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("g", {
                clipPath: "url(#clip0_3427_23140)",
                children: /*#__PURE__*/ jsxRuntime.jsx("path", {
                    d: "M81.7041 37.5247C81.7041 37.5247 81.6959 37.5449 81.6877 37.5651C81.6224 37.7267 80.0068 41.0233 75.1946 40.8644L76.0524 38.7427L79.6946 37.0178C80.0153 36.8654 80.1706 36.4814 80.0054 36.1325C79.8523 35.812 79.4676 35.6565 79.1184 35.8209L76.7796 36.9442L77.5149 35.1256C77.5149 35.1256 77.5149 35.1256 77.5231 35.1054C77.9134 34.7225 79.6206 33.2968 82.0099 34.2628C82.0301 34.271 82.0504 34.2792 82.0706 34.2874C82.5648 35.8037 81.7122 37.5044 81.7041 37.5247ZM75.5647 36.4531L74.6436 34.0117C74.5189 33.6792 74.1424 33.5034 73.8095 33.6275C73.4767 33.7515 73.293 34.1475 73.4177 34.48L74.8376 38.2515L73.9879 40.353C70.4175 37.1227 71.5755 33.6176 71.6125 33.468C71.6206 33.4478 71.6206 33.4478 71.6288 33.4276C71.637 33.4074 72.1858 31.5838 73.5949 30.837C73.6152 30.8452 73.6354 30.8534 73.6759 30.8698C76.0854 31.8439 76.2936 34.0676 76.3164 34.594C76.3164 34.594 76.3164 34.594 76.3082 34.6142L75.5647 36.4531ZM83.2244 33.5313C83.164 33.3893 83.0468 33.2714 82.9132 33.1939C80.6824 32.1274 78.7102 32.6936 77.4794 33.4655C77.1309 32.055 76.1266 30.2854 73.7612 29.4936C73.6195 29.4363 73.445 29.4598 73.3029 29.5199C71.2284 30.3974 70.4427 32.807 70.3731 33.0374C70.3077 33.1991 69.9433 34.3918 70.1532 36.0284C70.3472 37.588 71.1674 39.871 73.8007 41.9231C73.8209 41.9313 73.8412 41.9395 73.833 41.9597C73.8533 41.9679 73.8533 41.9679 73.8735 41.9761C73.8938 41.9842 73.8938 41.9842 73.914 41.9924C73.9343 42.0006 73.9747 42.017 73.995 42.0252C74.0152 42.0334 74.0557 42.0497 74.076 42.0579C74.0962 42.0661 74.0962 42.0661 74.1165 42.0743C74.1367 42.0825 74.1367 42.0825 74.157 42.0907C74.1772 42.0988 74.1975 42.107 74.2259 42.095C80.3827 42.774 82.666 38.5249 82.8578 38.1087C82.9271 37.9956 84.11 35.6526 83.2244 33.5313Z",
                    fill: theme.ds5.asset.grey["700"]
                })
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M30.126 20.2838C25.6354 20.2993 22.0105 23.9041 22.0258 28.3393C22.0308 29.7893 22.4266 31.1476 23.1113 32.3193C23.4741 32.9352 24.3175 32.9724 24.8289 32.4689L34.3264 23.0238C34.8327 22.5204 34.7943 21.6826 34.1631 21.3286C32.9721 20.6604 31.5941 20.2788 30.126 20.2838ZM35.4784 24.1538L25.9808 33.5988C25.4746 34.1023 25.513 34.9401 26.1442 35.2941C27.3352 35.9623 28.7132 36.3439 30.1813 36.3389C34.6719 36.3234 38.2968 32.7186 38.2815 28.2834C38.2765 26.8334 37.8807 25.4751 37.196 24.3034C36.8332 23.6875 35.9898 23.6503 35.4784 24.1538Z",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M44.2435 76.4468C40.3961 74.1308 35.4272 75.3326 33.1398 79.1325C32.392 80.3748 32.0258 81.7414 32.0036 83.0983C31.9943 83.813 32.6961 84.2823 33.3944 84.1171L46.4135 80.9681C47.1075 80.8002 47.5091 80.0641 47.1532 79.434C46.4815 78.2449 45.5013 77.2039 44.2435 76.4468ZM46.8123 82.5317L33.7932 85.6807C33.0992 85.8485 32.6976 86.5847 33.0535 87.2148C33.7252 88.4038 34.7054 89.4448 35.9632 90.202C39.8106 92.518 44.7795 91.3161 47.0669 87.5163C47.8147 86.274 48.1808 84.9074 48.2031 83.5505C48.2124 82.8357 47.5106 82.3664 46.8123 82.5317Z",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("defs", {
                children: /*#__PURE__*/ jsxRuntime.jsx("clipPath", {
                    id: "clip0_3427_23140",
                    children: /*#__PURE__*/ jsxRuntime.jsx("rect", {
                        width: "13.7593",
                        height: "11.77",
                        fill: "white",
                        transform: "translate(72 28.6641) rotate(22.0142)"
                    })
                })
            })
        ]
    });
};

exports.Supplements = Supplements;
//# sourceMappingURL=Supplements.cjs.map
